import type { ComponentProps } from 'react';
import { BorderContainer } from '../../../BorderContainer/BorderContainer';
import type { LotteryName } from '../../../lottery-purchases/types';
import { LotteryNumbers } from '../../../LotteryNumbers/LotteryNumbers';
import type { Drawing } from '../../types';

type MatchingInfo = {
  numbers?: number[];
  extraNumbers?: number[];
  isHighlighted?: boolean;
};

type LotteryResultProps = ComponentProps<typeof BorderContainer> & {
  result: Pick<Drawing, 'numbers' | 'extraNumbers'>;
  lotteryName: LotteryName;
  matching?: MatchingInfo;
};

function LotteryResult({ result, lotteryName, matching, ...props }: LotteryResultProps) {
  const classes = {
    numbers: 'px-5 py-2 mx-auto text-foreground',
  };
  return (
    <BorderContainer {...props}>
      <LotteryNumbers className={classes.numbers} line={result} lotteryName={lotteryName} matching={matching} />
    </BorderContainer>
  );
}

export { LotteryResult, type MatchingInfo };
